module.exports = __webpack_public_path__ + "dj.svg?63e20123441e1fe6998df866aceb2a4c";


//////////////////
// WEBPACK FOOTER
// ./node_modules/flag-icon-css/flags/1x1/dj.svg
// module id = 1070
// module chunks = 0